import type { I18nConfig } from '@portals-platform/brand-kit';
import { type ReactNode, Suspense, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n, initI18n } from './init.js';

interface I18nProviderProps {
  config: I18nConfig;
  children: ReactNode;
  /** Rendered while translations are loading */
  fallback?: ReactNode;
}

export function I18nProvider({ config, children, fallback = null }: I18nProviderProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initI18n(config).then(() => setReady(true));
  }, [config]);

  if (!ready) return <>{fallback}</>;

  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </I18nextProvider>
  );
}
